import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import { MotifIcon } from "@ey-xd/motif-react";
import React from "react";
import { useNavigate } from "react-router";
import { InternalErrorCode } from "../../utils/apiStatus.enum";
import "../../components/HttpError/HttpError.scss";
import "../../components/HttpError/NotFound.scss";
import searchNotFoundImg from "../../assets/images/not_found_error.svg";

interface NotFoundProps {
  theme?: string;
}

const NotFound: React.FC<NotFoundProps> = ({ theme = "dark" }) => {
  const navigate = useNavigate();

  const heading = "Error 404: Not found";
  const message = InternalErrorCode.NotFound;

  const goBackOrHome = () => {
    navigate("/", { replace: true });
  };

  return (
    <div className="http-error-container" motif-theme={theme}>
      <img
        className="error-illustration"
        src={searchNotFoundImg}
        alt="Error illustration"
      />
      <div className="error-separator" />

      <div className="http-error-header">{heading}</div>
      <div className="http-error-sub-header">{message}</div>

      <div className="error-actions" onClick={goBackOrHome}>
        <div className="error-btn">
          <MotifIcon
            fill={theme === "dark" ? "#5F5F72" : "#fff"}
            iconFunction={IconoirArrowLeft}
            size="24"
          />
          <div className="back-btn">Home</div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
